interface ReasonFields {
	[reason: string]: string;
}

export default class ProductStatus {
	value: string;

	reasonFields: ReasonFields;

	constructor(value: string, reasonFields: ReasonFields) {
		this.value = value;
		this.reasonFields = reasonFields;
	}

	isRemoved(): boolean {
		return this.value === 'removed';
	}

	isBeforeIntroduction(): boolean {
		return this.value === 'before-introduction';
	}

	isDanger(): boolean {
		return this.value === 'danger';
	}

	isWarning(): boolean {
		return this.value === 'warning';
	}

	isBeforeValidity(): boolean {
		return this.value === 'before-validity';
	}

	isAfterValidity(): boolean {
		return this.value === 'after-validity';
	}
}
